import { format, isAfter } from 'date-fns';

export default {
  init: ({ card }, _, internalStateSetter) => {
    const exceptions = [];
    if (card.move_in_date) {
      card.items.forEach((item) => {
        if (!item.completed && item.scheduled && isAfter(item.scheduled, card.move_in_date)) {
          exceptions.push(`${item.name} schedule date is after the move in date.`);
        }
      });
    }
    internalStateSetter('exceptions', exceptions);
  },
  'RowContainer.Row.PropertyCell': ({ action, card }, outlet) => {
    if (action === 'select_row') {
      outlet({ action: 'select_row', params: { card } });
    }
    if (action === 'view_card') {
      outlet({ action: 'open_modal', params: { item: null } });
    }
  },
  'RowContainer.Row.MoveOutCell': ({ selectedDate }, outlet) => {
    outlet({ action: 'change_card', params: { move_out_date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : null } });
  },
  'RowContainer.Row.MoveInCell': ({ selectedDate }, outlet) => {
    outlet({ action: 'change_card', params: { move_in_date: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : null } });
  },
  'RowContainer.Row.ReadyCell': ({ selectedDate }, outlet) => {
    outlet({ action: 'change_card', params: { deadline: selectedDate ? format(selectedDate, 'yyyy-MM-dd') : null } });
  },
  'RowContainer.Row.ItemCell': ({ action, payload, item, makeReadyCategory, card, data, inspectionTemplates }, outlet) => {
    if (action === 'reactivate') {
      outlet({ action: 'change_card', params: { hidden: false } });
    }
    if (action === 'archive') {
      if (window.settings.use_integration_for_make_ready_archiving) return;
      outlet({ action: 'change_card', params: { hidden: true } });
      return;
    }
    if (action === 'view_timeline') {
      outlet({ action: 'open_modal', params: { item, makeReadyCategory } });
    }
    if (action === 'view_media') {
      outlet({ action: 'view_media', params: { ...payload, item } });
    }
    if (action === 'select') {
      if (item?.id) {
        outlet({
          action: 'select',
          params: {
            make_ready_category_id: makeReadyCategory.id,
            card_id: card.id,
            is_complete: !!item.completed,
            is_assigned: !!item.tech_id || !!item.vendor_id || !!item.admin_id,
            is_scheduled: !!item.scheduled
          }
        });
      } else {
        outlet({
          action: 'select',
          params: {
            make_ready_category_id: makeReadyCategory.id,
            card_id: card.id,
            is_complete: false,
            is_assigned: false,
            is_scheduled: false
          }
        });
      }
    }
    if (action === 'toggle_complete') {
      if (item?.id) {
        if (!item.completed) {
          outlet({ action: 'complete', displayAction: 'completed', params: { ...item, make_ready_category_id: makeReadyCategory.id, card_id: card.id } });
        } else {
          outlet({ action: 'revert', displayAction: 'reopened', params: { ...item } });
        }
      } else {
        outlet({ action: 'complete', displayAction: 'completed', params: { card_id: card.id, scheduled: null, vendor_id: null, tech_id: null, make_ready_category_id: makeReadyCategory.id, name: makeReadyCategory.name } });
      }
    }
    if (action === 'schedule') {
      if (item?.id) {
        outlet({ action: 'change_item', displayAction: 'scheduled', params: { ...item, scheduled: payload?.selectedDate ? format(payload.selectedDate, 'yyyy-MM-dd') : null } });
      } else {
        outlet({ action: 'create', displayAction: 'scheduled', params: { card_id: card.id, scheduled: payload?.selectedDate ? format(payload.selectedDate, 'yyyy-MM-dd') : null, make_ready_category_id: makeReadyCategory.id, name: makeReadyCategory.name } });
      }
    }
    if (action === 'assign') {
      if (item?.id) {
        outlet({ action: 'assign', displayAction: !payload.selectedTechId && !payload.selectedTechId ? 'unassigned' : 'assigned', params: { ...item, tech_id: payload.selectedTechId, vendor_id: payload.selectedVendorId, admin_id: payload.selectedAdminId } });
      } else {
        outlet({ action: 'assign', displayAction: 'assigned', params: { card_id: card.id, tech_id: payload.selectedTechId, vendor_id: payload.selectedVendorId, make_ready_category_id: makeReadyCategory.id, name: makeReadyCategory.name, admin_id: payload.selectedAdminId } });
      }
    }
    if (action === 'note') {
      if (item?.id) {
        outlet({ action: 'comment', displayAction: 'note', params: { ...item, description: payload.value, attachment_uuids: payload.uuids } });
      } else {
        outlet({ action: 'create', displayAction: 'note', params: { card_id: card.id, description: payload.value, attachment_uuids: payload.uuids, make_ready_category_id: makeReadyCategory.id, name: makeReadyCategory.name } });
      }
    }
    if (action === 'changeData') {
      const cardData = {
        card_id: card.id,
        category_id: makeReadyCategory.id,
        data: payload,
        id: data?.id
      };
      outlet({ action: 'changeData', params: { cardData } });
    }
    if (action === 'changeTags') {
      const cardData = {
        card_id: card.id,
        category_id: makeReadyCategory.id,
        data: 'tags',
        tags: payload,
        id: data?.id
      };
      outlet({ action: 'changeData', params: { cardData } });
    }

    if (action === 'create_inspection') {
      let inspection = {
        template_id: makeReadyCategory.inspection_template_id,
        property_id: card.property.id,
        unit_ids: [card.unit.id],
        name: makeReadyCategory.name,
        unitNumber: card.unit.number,
        icon: makeReadyCategory.icon_name,
      }
      outlet({ action: 'create_inspection', params: { inspection } });
    }
  },

  'RowContainer.Row.OfficeSignOffCell': ({ card, disabled }, outlet) => {
    if (card.hidden || disabled) return;
    outlet({ action: 'change_card', params: { completion_status: card.completed_on ? 'incomplete' : 'completed' } });
  },
};
